module.exports = ".modal-dialog {\r\n  width: 60%!important;}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sendMoney/beneficiary/beneficiary.component.css
// module id = ./src/app/sendMoney/beneficiary/beneficiary.component.css
// module chunks = main